export default __webpack_public_path__ + "static/media/coming-soon.c567e989.jpg";